import React, { useEffect, useState, FC, useContext, useMemo } from 'react';
/* eslint-disable flowtype/no-types-missing-file-annotation */
export interface RecentCallItemAvatarProps {
    item: PhoneBookData,
    color: string,
}

const RecentCallItemAvatar: FC<RecentCallItemAvatarProps> = props => {
    const { item, color } = props;

    return (
        <>
            {item?.isGroupCall ? (
                <div
                    className = 'o-user-list-item-img o-user-list-item-avatar'>
                    <img
                        height = '19'
                        src = '../../../images/group-call.svg'
                        width = '22' />
                </div>
            ) : item?.avatar ? (
                <div style = {{ display: 'flex' }}>
                    <img
                        className = 'o-user-list-item-img'
                        height = '48'
                        src = { item.avatar }
                        width = '48' />
                    <div
                        className = { `o-user-list-item--status o-user-list-item--status--${color}` } />
                </div>
            ) : (
                <div
                    className = 'o-user-list-item-img o-user-list-item-group'>
                    <img
                        style = {{ borderRadius: '50%' }}
                        src = 'https://dev.pantherconnect.me/images/gen-avatar.jpg' />
                    <div
                        className = { `o-user-list-item--status o-user-list-item--status--${color}` } />
                </div>
            )}
        </>
    );
};

RecentCallItemAvatar.defaultProps = {
};

export default RecentCallItemAvatar;
